<template>
    <div id="recruiter_new_evaluations" class="flex_content" v-if="currentEval.saven_test">

        <div id="context_bar">
            <TopbarGoEvalsList />
<!--        <TopBarSteps /> -->
        </div>


        <titlePage v-if="!isLoading">
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">{{ currentEval.candidate_username }}</h1>
                <h2 class="associated_ref_name"><span>{{ getRefName(currentEval.saven_test.sight_ref) }}</span></h2>
                <h3 class="associated_rec_name" v-if="notOwnedEval"><span>{{ currentEval.recruiter_name }}</span></h3>


                <div class="edit_action_buttons">
                    <div class="add_to_position edit_action_button" v-if="canEditEval">
                        <AddToPositionModal :evaluation="currentEval" :positionsList="positionsList" />
                    </div>

                    <div v-if="currentEval.completed">
                        <div class="reports_dropdown edit_action_button" v-if="!currentEval.in_regen">
                            <ReportsDropDown
                                :doc_files="currentEval.docs_ids"
                                :expert_report_url="currentEval.saven_test.expert_report_url"
                                :passeport_report_url="currentEval.saven_test.passeport_report_url"
                                :customer_report_url="currentEval.saven_test.customer_report_url"/>
                        </div>
                        <div class="edit_action_button" v-else>
                            <ReportsInGen/>
                        </div>
                    </div>

                </div>
                <div class="edit_action_buttons" v-if="currentEval.completed">
                    <div class="add_to_position edit_action_button" v-if="canEditEval">
                        <ReportRegenModal :evaluation="currentEval" />
                    </div>
                </div>

            </template>
        </titlePage>


        <div class="eval_tabs_container" v-if="currentEval.completed" >
            <div class="eval_tabs">
                <BtnTab v-if="dimensionsPlan.show_soft_skills" btn-id="SkillsTab" :active-tab="currentTab == 'SkillsTab'" @btnTab:Clicked="changeTab">
                    {{ dimensionsPlan.soft_skills_title[$i18n.locale] }}
                </BtnTab>
                <BtnTab v-if="dimensionsPlan.show_respect2" btn-id="RespectTab" :active-tab="currentTab == 'RespectTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.evaluations.edit.respectTab') }}
                </BtnTab>
                <BtnTab v-if="dimensionsPlan.show_custom_skills" btn-id="CustomSkillsTab" :active-tab="currentTab == 'CustomSkillsTab'" @btnTab:Clicked="changeTab">
                    {{ dimensionsPlan.custom_skills_title[$i18n.locale] }}
                </BtnTab>
                <BtnTab v-if="dimensionsPlan.show_agilities" btn-id="AgilityTab" :active-tab="currentTab == 'AgilityTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.evaluations.edit.agilitiesTab') }}
                </BtnTab>
                <BtnTab v-if="dimensionsPlan.show_strengths" btn-id="StrengthTab" :active-tab="currentTab == 'StrengthTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.evaluations.edit.strengthsTab') }}
                </BtnTab>
                <BtnTab v-if="dimensionsPlan.show_strengths_custom" btn-id="StrengthTabCustom" :active-tab="currentTab == 'StrengthTabCustom'" @btnTab:Clicked="changeTab">
                    {{ dimensionsPlan.strenghts_custom_title[$i18n.locale]}}
                </BtnTab>
                <BtnTab v-if="dimensionsPlan.show_game_rules" btn-id="GameRulesTab" :active-tab="currentTab == 'GameRulesTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.evaluations.edit.gameRulesTab') }}
                </BtnTab>
            </div>

            <div class="tabs_content" >
                <div class="tabs_loader" v-if="!currentTab"><iconLoader  /></div>

                <transition name="survey-fade">
                    <component :is="currentTab" ></component>
                </transition>

            </div>
        </div>

        <div class="container uncompleted_container mini-container" v-else>
            <iconWarning />
            <h3 class="uncompleted_notice title is-size-3">
                {{ $t('modules.evaluations.edit.pendingEvalNotice') }}
            </h3>
            <div class="eval_link">
                <span>{{ $t('modules.evaluations.edit.app_link') }}</span>
                <input type="text" :value="currentEval.eval_link" readonly/>
            </div>
        </div>

    </div>

</template>

<script>

import TitlePage from "@/components/layouts/titlePage"
import TopbarGoEvalsList from "../components/topbar/topbarGoEvalsList"

import SkillsTab from "../components/edit/skillsTab"
import AgilityTab from "../components/edit/agilityTab"
import StrengthTab from "../components/edit/strengthTab"
import StrengthTabCustom from "../components/edit/strengthCustomTab"

import CustomSkillsTab from "../components/edit/customSkillsTab"
import RespectTab from "../components/edit/respectTab"
import GameRulesTab from "../components/edit/gameRulesTab"


import AddToPositionModal from '../components/index/addToPositionModal'
import ReportsDropDown from '../components/index/reportsDropDown'
import ReportsInGen from '../components/index/ReportsInGen'
import ReportRegenModal from '../components/edit/reportRegenModal'


import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'


export default {
    name: 'EvaluationsEdit',
    components: {
        TopbarGoEvalsList,
        TitlePage,
        SkillsTab,
        AgilityTab,
        StrengthTab,
        RespectTab,
        CustomSkillsTab,
        GameRulesTab,
        AddToPositionModal,
        ReportsDropDown,
        ReportsInGen,
        ReportRegenModal,
        StrengthTabCustom
    },
    beforeCreate() {
        this.$store.dispatch('EvalStore/initEdit', this.$route.params.id).then( () => {this.isLoading = false})
        this.$store.dispatch('PositionStore/indexPositions', {})
    },
    mounted(){
        setTimeout(() => {
            if (this.dimensionsPlan.show_soft_skills){
                this.currentTab = 'SkillsTab'
            }else if (this.dimensionsPlan.show_respect2){
                this.currentTab = 'RespectTab'
            }else if (this.dimensionsPlan.show_custom_skills){
                this.currentTab = 'CustomSkillsTab'
            }else if (this.dimensionsPlan.show_agilities){
                this.currentTab = 'AgilityTab'
            }else if (this.dimensionsPlan.show_strengths){
                this.currentTab = 'StrengthTab'
            }else if (this.dimensionsPlan.show_strengths_custom){
                this.currentTab = 'StrengthTabCustom'
            }
        }, 1000 )
        this.checkReportsRegen()
    },
    data(){
        return {
            isLoading: true,
            currentTab: false,
            intervalId: "",
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        dimensionsPlan(){
            return this.$store.state.EvalStore.currentEval.saven_test.dimensions_plan
        },
        positionsList(){
            return this.$store.state.PositionStore.positionsList
        },
        notOwnedEval(){
            return this.userData.id != this.currentEval.user_id
        },
        shareModeActive(){
            return JSON.parse(localStorage.getItem('account')).contract.sharing_data_mode == "across_company"
        },
        canEditEval(){
            return !this.notOwnedEval || this.shareModeActive
        },
        isRespect(){
            return JSON.parse(localStorage.getItem('account')).is_respect
        }
    },
    methods: {
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        isActive(tabName){

        },
        changeTab(tabName){
            this.currentTab = tabName
        },
        checkReportsRegen(){
            this.intervalId = setInterval(() => {
                if (this.currentEval){
                    if (this.currentEval.in_regen){
                        if (this.$route.params.id){
                            console.log("EDIT EVAL")
                            this.$store.dispatch('EvalStore/initEdit', this.$route.params.id)
                        }
                    }
                }
            }, 5000)
        }
    },
    beforeDestroy () {
       clearInterval(this.intervalId)
    }
}
</script>

<style lang="scss" scoped>
#index_eval_content{
    background: $white;
}
.form_material_container{
    max-width: 500px;
    margin: 0 auto;
    .select{
        width: 100%;
        select{
            width: 100%;
        }
    }
}
.tabs_loader{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    svg{
        width: 50px;
        fill: $info;
    }
}
.eval_tabs_container{
    flex: 1;
    background: #f5f5f5;
}
.eval_tabs{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    background-color: $white;
    background: #f5f5f5;
    border-bottom: 1px solid #0000000f;
    border-top: 1px solid #0000000f;
}
.uncompleted_container{
    text-align: center;
    margin: 50px auto;
    svg{
        width: 80px;
        fill: $pending-color;
    }
    .uncompleted_notice{
        max-width: 500px;
        margin: auto;
        color: $pending-color;
    }
}
.edit_action_buttons{
    display: flex;
    justify-content: center;
    .edit_action_button{
        margin: 8px 4px;
    }
}
.associated_rec_name{
    text-align: center;
    font-style: italic;
    font-weight: 600;
    color: $primary;
    font-size: 1.2rem;
}
.eval_link{
    width: 100%;
    margin-top: 30px;
    span{
        font-size: 1.25rem;
    }
    input{
        text-align: center;
        width: 100%;
        border: 1px solid #80808045;
        padding: 12px;
        border-radius: 10px;
    }
}
</style>